import { useEffect, useState } from "react";
import Header from "../components/Header/Header";
import Email from "../components/Email/Email";
import PostalMail from "../components/PostalMail/PostalMail";
import Phone from "../components/Phone/Phone";
import Mobile from "../components/Mobile/Mobile";
import Fax from "../components/Fax/Fax";
import SMS from "../components/SMS/SMS";
import WhatsApp from "../components/WhatsApp/WhatsApp";
import Bottom from "../components/Bottom/Bottom";
import { cmsDefault } from "../../constants/DefaultCMS";
import { useSelector } from "react-redux";
import NamesSection from "../components/NamesSection/NamesSection";
import ListRemovalSuccess from "../components/ListRemovalSuccess/ListRemovalSuccess";
import ListRemovalFailure from "../components/ListRemovalFailure/ListRemovalFailure";
import Banner from "../components/Banner/Banner";
import "./ListRemoval.css";
import { glassboxErrorEvent } from "../../core/components/Glassbox/Glassbox";

const ListRemoval = () => {
  const [state, setState] = useState(cmsDefault);
  const [listRemovalSuccess, setListRemovalSuccess] = useState(null);
  const [traceToken, setTraceToken] = useState("");

  const { country, language } = useSelector((state) => state.langSettings);

  useEffect(() => {
    const getCMSData = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_PMC_CMS_URL}${encodeURIComponent(
            country
          )}/${encodeURIComponent(language)}`
        );

        const data = await res.json();

        if (data.length > 0) {
          const liveMap = new Map(data.map((item) => [item.key, item]));
          const merged = cmsDefault.map((def) => {
            const live = liveMap.get(def.key);
            return live?.value?.microContentValue ? live : def;
          });
          data.forEach((item) => {
            if (!cmsDefault.some((def) => def.key === item.key)) {
              merged.push(item);
            }
          });
          setState(merged);
          // document.documentElement.setAttribute("lang", language);
        }
      } catch (err) {
        console.log(`ListRemoval Error: ${err}`);
        glassboxErrorEvent(err);
      }
    };
    getCMSData();

    const getTraceToken = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_PMC_LIST_REMOVAL_URL}/traceid`);
        if (res.ok) {
          const data = await res.json();
          setTraceToken(data.token ?? "");
        }
      } catch (err) {
        console.log(`TraceId fetch error: ${err}`);
      }
    };
    getTraceToken();
  }, [country, language]);

  return (
    <>
      <Banner cmsLabels={state} />
      <div className="dds__m-5 dds__p-4 dds__container dds__elevation-4 list-removal">
        {listRemovalSuccess === null && (
          <div>
            <Header cmsLabels={state} />
            <form data-dds="form-validation">
              <Email cmsLabels={state} />
              <PostalMail cmsLabels={state} />
              <Phone cmsLabels={state} />
              <Mobile cmsLabels={state} />
              <Fax cmsLabels={state} />
              <SMS cmsLabels={state} />
              <WhatsApp cmsLabels={state} />
              <NamesSection cmsLabels={state} />
              <Bottom
                cmsLabels={state}
                setListRemovalSuccess={setListRemovalSuccess}
                traceToken={traceToken}
              />
            </form>
          </div>
        )}

        {listRemovalSuccess === true && (
          <ListRemovalSuccess cmsLabels={state} />
        )}

        {listRemovalSuccess === false && (
          <ListRemovalFailure cmsLabels={state} />
        )}
      </div>
    </>
  );
};
export default ListRemoval;
